import React, { useState, Fragment } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import Input from '../../generic/Input'
import Button from '../../generic/Button'
import { IconButton } from '@material-ui/core'
import { RemoveCircle } from '@material-ui/icons'
import { requestAPI } from '../../data/api.js'

export default function ImageSupplierPattern(props) {
	const { fetchPatternDomains, clientId, id } = props
	const [initialPattern, setInitialPattern] = useState(props.pattern)
	const [initialDomains, setInitialDomains] = useState(props.domains)
	const [pattern, setPattern] = useState(initialPattern)
	const [domains, setDomains] = useState(initialDomains)
	const [deleting, setDeleting] = useState(false)

	const reset = () => {
		setPattern(initialPattern)
		setDomains(initialDomains)
		setDeleting(false)
	}

	const handleSave = async () => {
		await updatePattern(clientId, id, pattern, domains)
		setInitialPattern(pattern)
		setInitialDomains(domains)
	}

	const handleDelete = async () => {
		await deletePattern(clientId, id)
		await fetchPatternDomains()
	}

	const renderActions = () => {
		if (deleting) { return (
			<Fragment>
				<Button onClick={handleDelete}>Save</Button>
				<Button onClick={reset}>Cancel</Button>
			</Fragment>
		)}
		if (pattern !== initialPattern || domains !== initialDomains) { return (
			<Fragment>
				<Button onClick={handleSave} disabled={pattern === '' || domains === ''}>Save</Button>
				<Button onClick={reset}>Cancel</Button>
			</Fragment>
		)}
		return (
			<IconButton className='btn' type='submit' size='small' onClick={() => setDeleting(true)}>
				<RemoveCircle className='icon-btn' />
			</IconButton>
		)
	}

	return (
		<TableRow key={id}>
			<TableCell>
				<Input
					className={deleting ? 'crossed' : ''}
					placeholder='\yAFP\y|\yAP\y'
					value={pattern}
					onChange={e => setPattern(e.target.value)}
					disabled={deleting}
				/>
			</TableCell>
			<TableCell>
				<Input
					className={deleting ? 'crossed' : ''}
					placeholder='.com,facebook.com'
					value={domains}
					onChange={e => setDomains(e.target.value)}
					disabled={deleting}
				/>
			</TableCell>
			<TableCell padding='none'>
				<div className='action-section column-width'>
					{renderActions()}
				</div>
			</TableCell>
		</TableRow>
	)
}

function updatePattern(clientId, patternId, pattern, domains) {
	return requestAPI(
		`/include-domains/image-supplier-patterns/${patternId}`,
		'PUT',
		{ clientId, pattern, domains },
	)
}

function deletePattern(clientId, patternId) {
	return requestAPI(
		`/include-domains/image-supplier-patterns/${patternId}`,
		'DELETE',
		{ clientId },
	)
}
